import { Path, Svg } from 'react-native-svg';
import { withDefaultIconProps } from './index';
import { CheckCircle } from './check-circle';

import { View } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export const PinPoint = withDefaultIconProps({ color: '#ffffff', height: 16, width: 16 }, ({ color, ...rest }) => (
  <Svg {...rest} viewBox="0 0 16 16" fill="none">
    <Path
      d="M8 11.207a.407.407 0 00.407-.407V5.822a1.867 1.867 0 10-.814 0V10.8c0 .225.182.407.407.407zm.333-8.274a.733.733 0 110 1.467.733.733 0 010-1.467z"
      fill={color}
    />
    <Path
      d="M5.768 8.672a6.404 6.404 0 00-1.246.444c-1.389.677-1.596 1.529-1.596 1.976 0 .447.207 1.298 1.596 1.975.936.457 2.17.708 3.478.708 1.307 0 2.543-.251 3.479-.708 1.388-.677 1.595-1.528 1.595-1.975 0-.447-.207-1.299-1.595-1.976-.37-.18-.79-.33-1.246-.444a.407.407 0 10-.199.79c.403.1.769.23 1.087.386.724.353 1.138.806 1.138 1.244 0 .437-.414.89-1.138 1.243-.827.403-1.935.625-3.12.625-1.187 0-2.295-.222-3.122-.625-.723-.353-1.138-.806-1.138-1.243 0-.438.415-.89 1.138-1.244a5.59 5.59 0 011.087-.386.407.407 0 00-.198-.79z"
      fill={color}
    />
  </Svg>
));

export const PinPointWithCheck = withDefaultIconProps(
  { color: '#ffffff', height: 16, width: 16 },
  ({ color, width, height, ...rest }) => (
    <View>
      <CheckCircle
        color={color}
        fillColor={theme.colors.white}
        width={(width as number) * 0.45}
        height={(height as number) * 0.45}
        style={{ zIndex: 1, position: 'absolute', bottom: 0, right: (width as number) * 0.05 }}
      />
      <Svg {...rest} width={width} height={height} viewBox="0 0 16 16" fill="none">
        <Path
          d="M8 11.207a.407.407 0 00.407-.407V5.822a1.867 1.867 0 10-.814 0V10.8c0 .225.182.407.407.407zm.333-8.274a.733.733 0 110 1.467.733.733 0 010-1.467z"
          fill={color}
        />
        <Path
          d="M5.768 8.672a6.404 6.404 0 00-1.246.444c-1.389.677-1.596 1.529-1.596 1.976 0 .447.207 1.298 1.596 1.975.936.457 2.17.708 3.478.708 1.307 0 2.543-.251 3.479-.708 1.388-.677 1.595-1.528 1.595-1.975 0-.447-.207-1.299-1.595-1.976-.37-.18-.79-.33-1.246-.444a.407.407 0 10-.199.79c.403.1.769.23 1.087.386.724.353 1.138.806 1.138 1.244 0 .437-.414.89-1.138 1.243-.827.403-1.935.625-3.12.625-1.187 0-2.295-.222-3.122-.625-.723-.353-1.138-.806-1.138-1.243 0-.438.415-.89 1.138-1.244a5.59 5.59 0 011.087-.386.407.407 0 00-.198-.79z"
          fill={color}
        />
      </Svg>
    </View>
  ),
);
